// extracted by mini-css-extract-plugin
export default {"contactsAndLogin":"ContactsAndLogin_contactsAndLogin__a+xWj","cardEmail":"ContactsAndLogin_cardEmail__FnMUD"};